import React, {Component} from "react";
import "./UserCreate.css";
import {FormattedMessage} from "react-intl";
import FormFieldValidationError from '../../Common/FormFieldValidationError/FormFieldValidationError';
import axios from 'axios';
import {RESOURCE_BASE_URL} from "../../../configuration";
import Redirect from "react-router-dom/es/Redirect";
import InitialQuotationState from "../../Site/QuotationForm/InitialQuotationState";
import {Link} from "react-router-dom";
import Modal from "react-bootstrap/es/Modal";

const ToggleRoleSelectOptions = (props) => {
    let lang = InitialQuotationState.lang;

    if(lang === "ja"){
        return(
                props.roles.map(role=>{
                   return <option value={role}>{role ==="chat_admin" ? "チャット管理者" : role === "admin" ? "管理者" : role === "manager" ? "部長" : ""}</option>
                })
        )
    }else{
        return(
            props.roles.map(role=>{
                return <option value={role}>{role}</option>
            })
        )
     }
};

class UserCreate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            role: "",
            primaryAddress: "",
            phone: "",
            nameError: "",
            emailError: "",
            usernameError: "",
            phoneError: "",
            roleError: "",
            addressError: "",
            user: [],
            redirect: false,
            // keycloakUserRoles : [],
            UserRoles : [],
            show : false,
            showExistingUserDialog : false,
            username : ""
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.validateName = this.validateName.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.validateRole = this.validateRole.bind(this);
        this.validateAddress = this.validateAddress.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleCloseExistingUser = this.handleCloseExistingUser.bind(this);
        this.handleShowExistingUser = this.handleShowExistingUser.bind(this);
    }

    componentDidMount() {
        let roles = [];
        this.setState({
            UserRoles: this.props.userData.userRoles
        })
    }
    handleClose = () => {
        this.setState({
            show : false,
            redirect: true
        })
    };

    handleCloseExistingUser = () => {
      this.setState({
          showExistingUserDialog : false,
          name : "",
          email : "",
          primaryAddress : "",
          phone : "",
          username : "",
          role : ""
      })
    };

    handleShowExistingUser = () => {
        this.setState({
            showExistingUserDialog : true
        })
    };



    handleShow = () => {
        this.setState({
            show : true
        })
    };


    validateName = () => {
        let name = this.state.name;
        return (name !== "");
    };

    validateEmail = () => {
        let email = this.state.email;
        let pattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;

        return email.match(pattern);
    };

    validateUsername = () => {
        let pattern = /\s/;
        let username = this.state.username;
        if(username === "" || pattern.test(username)){
            return false
        }
        return true;
    };

    validateRole = () => {
        let role = this.state.role;
        return (role !== "");
    };

    validateAddress = () => {
        let address = this.state.primaryAddress;
        return (address !== "");
    };

    validatePhone = () => {
        let phone = this.state.phone;
        let pattern = /^[0-9]*$/;
        if (phone === "" || !phone.match(pattern)) {
            this.setState({
                phoneError: "app.validation.user-profile.user-add-address.empty-contact"
            });
            return false;
        }
        return true;
    };

    onInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            nameError: "",
            emailError: "",
            usernameError: "",
            roleError: "",
            addressError: "",
            phoneError: "",
        });
    };

    onSelectChange = (event) => {
        this.setState({
            role: event.target.value,
            roleError: ""

        });
    };

    onSubmit = (event) => {
        let nameError = "";
        let emailError = "";
        let roleError = "";
        let addressError = "";
        let phoneError = "";
        let usernameError = "";
        let validationPassed = true;

        if (!this.validateName(event)) {
            validationPassed = false;
            nameError = "app.validation.user-creation.invalid-name";
        }
        if (!this.validateEmail(event)) {
            validationPassed = false;
            emailError = "app.validation.user-creation.invalid-email";
        }

        if (!this.validateRole(event)) {
            validationPassed = false;
            roleError = "app.validation.user-creation.invalid-role";
        }

        if (!this.validateAddress(event)) {
            validationPassed = false;
            addressError = "app.validation.user-creation.invalid-address";
        }

        if (!this.validatePhone(event)) {
            validationPassed = false;
            phoneError = "app.validation.user-profile.user-add-address.empty-contact";
        }

        if(!this.validateUsername(event)){
            validationPassed = false;
            usernameError = "app.validation.user-creation.invalid-username"
        }

        if (validationPassed) {
            // console.log("Validation passed");

            let postData = {
                name : this.state.name,
                japaneseFirstName: "",
                japaneseLastName : "",
                email: this.state.email,
                userRole: this.state.role,
                gender : "",
                primaryAddress: this.state.primaryAddress,
                phone: this.state.phone,
                shippingAddressId : -1,
                billingAddressId : -1,
                username : this.state.username
            };

            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Access-Control-Allow-Origin': '*'
                }
            };

            axios.post(RESOURCE_BASE_URL + 'api/admins', postData, axiosConfig)
                .then((res) => {
                    this.setState({
                        show : true
                    });
                    // console.log(res.data);
                    // console.log("User created successfully");
                })
                .catch((err) => {
                    console.log("AXIOS ERROR: ", err);
                    this.handleShowExistingUser();
                });
            event.preventDefault();
        } else {
            event.preventDefault();
            this.setState({nameError, emailError, roleError, addressError, phoneError, usernameError});
        }
    };

    render() {

        const {redirect} = this.state;

        if (redirect) {
            return <Redirect to='/admin/users/all'/>;
        }

        return (
            <div className="user-creation-content">
                <div className="user-creation-div">
                    <form onSubmit={this.onSubmit}>
                        <div className="title-1 text-align-left">
                            <FormattedMessage id="app.user-creation.title"
                                              defaultMessage="NEW USER"
                                              description=""/>
                        </div>
                        <hr/>

                        {/*Name field*/}
                        <div className="user-creation-row-margin">
                            <div className="row">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-creation.name"
                                                              defaultMessage="Name"
                                                              description=""/>
                                            <span className="mandatory-star"> *</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">
                                    <input type="text"
                                           className="form-control"
                                           name="name"
                                           value={this.state.name}
                                           onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.nameError}/>
                            </div>
                        </div>

                        {/*Email field*/}
                        <div className="user-creation-row-margin">
                            <div className="row">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-creation.email"
                                                              defaultMessage="Email"
                                                              description=""/>
                                            <span className="mandatory-star"> *</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">
                                    <input type="text"
                                           className="form-control"
                                           name="email"
                                           value={this.state.email}
                                           onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.emailError}/>
                            </div>
                        </div>

                        {/*Address field*/}
                        <div className="user-creation-row-margin">
                            <div className="row">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-creation.primary-address"
                                                              defaultMessage="Address"
                                                              description=""/>
                                            <span className="mandatory-star"> *</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">
                                    <input type="text"
                                           className="form-control"
                                           name="primaryAddress"
                                           value={this.state.primaryAddress}
                                           onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.addressError}/>
                            </div>
                        </div>

                        {/*Phone field*/}
                        <div className="user-creation-row-margin">
                            <div className="row">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-creation.phone"
                                                              defaultMessage="Phone"
                                                              description=""/>
                                            <span className="mandatory-star"> *</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">
                                    <input type="text"
                                           className="form-control"
                                           name="phone"
                                           value={this.state.phone}
                                           onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.phoneError}/>
                            </div>
                        </div>

                        {/*username field*/}
                        <div className="user-creation-row-margin">
                            <div className="row">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-creation.username"
                                                              defaultMessage="Username"
                                                              description=""/>
                                            <span className="mandatory-star"> *</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">
                                    <input type="text"
                                           className="form-control"
                                           name="username"
                                           value={this.state.username}
                                           onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.usernameError}/>
                            </div>
                        </div>

                        {/*Role field*/}
                        <div className="user-creation-row-margin">
                            <div className="row">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.user-creation.role"
                                                              defaultMessage="Role"
                                                              description=""/>
                                            <span className="mandatory-star"> *</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-4 no-padding-left ">
                                    <select className="form-control" name="role" value={this.state.role}
                                            onChange={this.onSelectChange}>
                                        <option value="">--{InitialQuotationState.lang === "ja" ? "役割を選択" : "Choose Role"}--</option>
                                        <ToggleRoleSelectOptions roles = {this.state.UserRoles}/>

                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.roleError}/>
                            </div>
                        </div>

                        {/*/!*Password send field*!/*/}
                        {/*<div className="user-creation-row-margin">*/}
                            {/*<div className="row">*/}
                                {/*<div className="col-md-2"></div>*/}
                                {/*<div className="col-md-8 no-padding-left">*/}
                                    {/*<span className="send-password-checkbox">*/}
                                        {/*<input type="checkbox"/>&nbsp;*/}
                                    {/*</span>*/}
                                    {/*<span className="send-password-label">*/}
                                        {/*<FormattedMessage id="app.user-creation.send-password"*/}
                                                          {/*defaultMessage="Send temporary password in Email"*/}
                                                          {/*description=""/>*/}
                                    {/*</span>*/}
                                {/*</div>*/}
                            {/*</div>*/}
                        {/*</div>*/}

                        <div className="row">
                            <div className="user-creation-row-margin">
                                <div className="col-md-2 col-md-offset-2">
                                    <button className="btn btn-success" type="submit">
                                        <FormattedMessage id="app.user-creation.create"
                                                          defaultMessage="Create"
                                                          description=""/>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="user-creation-row-margin">
                                <div className="pull-right">
                                    <Link to={"/admin/users/all"} className="">
                                        <FormattedMessage id="app.admin-info.back"
                                                          defaultMessage="<< Back"
                                                          description=""/>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <Modal dialogClassName="message-modal" show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.user-creation.success"
                                              defaultMessage="Success"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-8 data-label">

                                    <FormattedMessage id="app.user-creation.success-message"
                                                      defaultMessage="Admin user created successfully"
                                                      description=""/>

                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right" onClick={this.handleClose}>
                                <FormattedMessage id="app.common.msg-box.close"
                                                  defaultMessage="Close"
                                                  description=""/>
                            </button>

                        </div>
                    </Modal.Footer>
                </Modal>


                {/*Existing user dialog ---------------------------------*/}
                <Modal dialogClassName="message-modal" show={this.state.showExistingUserDialog} onHide={this.handleCloseExistingUser}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.user-creation.fail"
                                              defaultMessage="Could not create the admin user"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-8 data-label">

                                    <FormattedMessage id="app.user-creation.fail-message"
                                                      defaultMessage="Admin user exists for the entered email."
                                                      description=""/>

                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right" onClick={this.handleCloseExistingUser}>
                                <FormattedMessage id="app.common.msg-box.close"
                                                  defaultMessage="Close"
                                                  description=""/>
                            </button>

                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default UserCreate;



// WEBPACK FOOTER //
// ./src/components/Admin/UserCreate/UserCreate.js